export const TOKEN_REGEX = new RegExp(/^token=[0-9A-Fa-f]{8}(?:-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}$/);